import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  ContainerPrincipal,
} from './ValoresAPagarPelaABEStyles';

function ValoresAPagarPelaABEComponent() {
  return (
    <ContainerPrincipal>
      <p>Aguarde!  Opção em desenvolvimento</p>
    </ContainerPrincipal>
  );
}

export const ValoresAPagarPelaABE = withRouter(ValoresAPagarPelaABEComponent);
